import apiServices, { connectorClient } from "../utils/axios";

export const fetchMigrateData = async (payload) => {
    const res = await apiServices.post(`/migration/load`, payload);
    return res.data;
};

export const fetchMigrateSchedule = async (payload) => {
  const res = await apiServices.post(`/migration/schedule`, payload);
  return res.data;
};

export const fetchScheduleList = async (param) => {
  const res = await apiServices.get(`/schedules?task_type=${param}`);
  return res.data;
};

export const fetchDeleteSchedule = async (id) => {
  const res = await apiServices.delete(`/schedules/${id}`);
  return res.data;
};

